import React from 'react';
import { useIntl } from 'react-intl';

import Typography from 'carbon-react/lib/components/typography/typography.component';

import { CombinedSubEntityForecastData } from '@futrli/views/combiners/subEntityForecastsCombiner';

import { SubEntityForecastSelect } from './sub-entity-forecast-select/sub-entity-forecast-select';

import styles from './sub-entity-forecasts.scss';

export interface SubEntityForecastsProps {
  errors: Record<string, { message?: string }>;
  onChangeSourceSubEntity: (entityId: string) => void;
  onChangeSourceSubEntityForecast: (entityId: string, forecastId: string) => void;
  sourceSubEntityForecasts: Record<string, string>;
  subEntityForecasts?: CombinedSubEntityForecastData;
  type: 'budget' | 'forecast';
}

export const SubEntityForecasts = ({
  errors,
  onChangeSourceSubEntityForecast,
  onChangeSourceSubEntity,
  subEntityForecasts,
  sourceSubEntityForecasts,
  type
}: SubEntityForecastsProps) => {
  const intl = useIntl();

  const [label, sublabel] = (() => {
    if (type === 'budget') {
      return [
        intl.formatMessage({
          id: 'predict.create_forecast.select_budgets_to_combine',
          defaultMessage: 'Select budgets to combine'
        }),
        intl.formatMessage({
          id: 'predict.create_forecast.you_can_add_one_budget_per_organisation',
          defaultMessage: 'You can add one budget per organisation'
        })
      ];
    } else {
      return [
        intl.formatMessage({
          id: 'predict.create_forecast.select_forecasts_to_combine',
          defaultMessage: 'Select forecasts to combine'
        }),
        intl.formatMessage({
          id: 'predict.create_forecast.you_can_add_one_forecast_per_organisation',
          defaultMessage: 'You can add one forecast per organisation'
        })
      ];
    }
  })();

  return (
    <fieldset name="sub-entity-forecasts">
      <Typography className={styles.label} variant="strong" mb={0}>
        {label}
      </Typography>
      <Typography className={styles.sublabel} variant="p" mb={0}>
        {sublabel}
      </Typography>
      {Object.entries(subEntityForecasts || {}).map(([subEntityId, entity]) => (
        <SubEntityForecastSelect
          error={errors[`sub-entity-forecast-${subEntityId}`]?.message}
          forecasts={entity.forecasts}
          isChecked={typeof sourceSubEntityForecasts[subEntityId] === 'string'}
          key={subEntityId}
          mt={1}
          name={entity.name}
          organisationId={subEntityId}
          onChangeCheckbox={onChangeSourceSubEntity}
          onSelectForecast={onChangeSourceSubEntityForecast}
          type={type}
          value={sourceSubEntityForecasts[subEntityId] || ''}
        />
      ))}
    </fieldset>
  );
};
